/**
 * @file
 * The sidebar displaying data for markers that are clicked in BasstrakkMap component.
 */
import * as React from 'react';

// Components
import Time from '../../../components/Time/Time';

// Utils
import isEqual from 'lodash/isEqual';

// Types
import { IMarker } from '../types';

interface IProps {
  defaultLat: number;
  defaultLng: number;
  sidebarData: IMarker;
}

// Sidebar string denoting manually altered lat / lng marker data.
const BAD_LAT_LNG = '* Lat / Long data unavailable and may not be accurate.';

class BasstrakkMapSidebar extends React.PureComponent<IProps> {
  public render() {
    const { sidebarData, defaultLat, defaultLng } = this.props;

    return (
      <div className="basstrakk-map__profile-pane" data-testid="map-sidebar">
        <div
          className={`basstrakk-map__profile-pane__side-profile pane__side-profile${
            !sidebarData.anglerId && '--hide'
          }`}
        >
          <div className="side-profile__name">{sidebarData.anglerName}</div>
          {sidebarData.lastLocationTime && (
            <div className="side-profile__time">
              <Time time={sidebarData.lastLocationTime} />
            </div>
          )}
          <div className="side-profile__coordinates">
            <span>Coordinates (Lat / Long): </span>
            {sidebarData.position &&
              `${sidebarData.position[0]} / ${sidebarData.position[1]}`}
            <br />
            {/*Flag to denote that lat / lng was manually altered to account for bad data.*/}
            {sidebarData.position &&
              isEqual([defaultLat, defaultLng], sidebarData.position) &&
              BAD_LAT_LNG}
          </div>
          <div
            className={`side-profile__catch side-profile__catch${
              !sidebarData.showCatchesDiv && '--hide'
            }`}
            data-testid="sidebar-catches"
          >
            <div className="side-profile__catch__title">This Catch:</div>
            {sidebarData.time && (
              <div className="side-profile__catch__time">
                <Time time={sidebarData.time} />
              </div>
            )}
            <div className="side-profile__catch__weight">
              {sidebarData.fishWeightPdsOz}
            </div>
          </div>
          <div className="side-profile__day-totals">
            <div className="side-profile__day-totals__title">
              Tournament Total:
            </div>
            <div className="side-profile__day-totals__count">
              {sidebarData.sumFish}
            </div>
            <div className="side-profile__day-totals__weight">
              {sidebarData.sumPdsOz}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default BasstrakkMapSidebar;
